<template>
	<div class="">
		<!-- Loader -->
		<div class="d-none" id="preloader">
			<div id="status">
				<div class="spinner-chase">
					<div class="chase-dot"></div>
					<div class="chase-dot"></div>
					<div class="chase-dot"></div>
					<div class="chase-dot"></div>
					<div class="chase-dot"></div>
					<div class="chase-dot"></div>
				</div>
			</div>
		</div>

		<div class="LayoutLogin">
			<main class="LayoutLogin__main">
				<slot />
			</main>
		</div>
	</div>
</template>

<script>
import axios from "axios";
axios.defaults.withCredentials = true;

import cookie from "js-cookie";
import config from "../config/settings.js";

export default {
	name: "Horizontal",
	data() {
		return {
			// api: "http://corp.pau.go.ug/api",
			api: config.API_URL,
			message: "",
			http_code: "",
			user: null,
			registry_depts: ["13", "15", "30", "43", "45", "60", "61", "70", "72"],
			// staff_depts: ["13", "15", "30", "43", "45", "60", "61", "70", "72"],
			staff_depts: ["13", "15", "30", "43", "45", "60", "61", "70", "72"],
			stakeholder_depts: ["0"],
			events_depts: ["0"],
			reporting_depts: ["3", "77"],
			settings_depts: ["23", "42", "71"],
			user_department: "",
			management_level: "",
		};
	},
	computed: {},
	methods: {
		forwardUser(link) {
			this.$router.push(link);
		},
		getCookie() {
			let token = cookie.get("XSRF-TOKEN");
			if (token) {
				return new Promise((resolve) => {
					resolve(token);
				});
			} else {
				return axios.get(this.api + "/csrf-cookie");
			}
		},
	},
	mounted() {
		localStorage.clear();
		sessionStorage.clear();
	},
};
</script>


<style scoped>
@font-face {
	font-family: HeaderCustomFont;
	color: honeydew;
	src: url(@/assets/fonts/Nunito/Nunito-Black.ttf) format("truetype");
}

@font-face {
	font-family: BodyCustomFont;
	color: honeydew;
	src: url(@/assets/fonts/quicksand/Quicksand-Bold.otf) format("otf");
}

@font-face {
	font-family: SansCustomFont;
	color: honeydew;
	src: url(@/assets/fonts/open-sans/OpenSans-Semibold.ttf) format("truetype");
}

#login-form:focus {
	opacity: 1;
}

.form-label {
	font-family: HeaderCustomFont;
}

.form-control {
	font-family: HeaderCustomFont;
	border-color: #aed6f1;
	/* border-color: #D6EAF8; */
}

.form-control::placeholder {
	color: #d5d8dc !important;
}

.form-control,
.btn {
	-webkit-border-radius: 0px;
	-moz-border-radius: 0px;
	border-radius: 0px;
}

.text-fix {
	text-align: left !important;
}

.root {
	position: absolute;
}

.modal {
	/* background-color: rgba(0,0,0,0.1); */
	/* width: 50%;
    height: 75%; */
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	border-radius: 0px;
}

.modal > div {
	background-color: #fff;
	border-radius: 0px;
}

.form-control:focus {
	border-color: #3498db;
	box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(52, 152, 219);
}

.small-icon {
	width: 50px;
	height: 50px;
}
</style> 
